/**
 * What the pricing page tells search engines and link previews — ONE copy, read by today's page (src/pages/Pricing.tsx)
 * and its rebuild in the new design (src/design/pavilion/pages/pricing/), the way src/config/aboutSeo.ts serves both
 * about pages (design record §7b).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/pricing"): its extractor takes a `title:` field whose string sits on the same line, so it stays one line.
 */
import { MONTHLY_WU_PER_PRESTON, WU_FULL_NAME, WU_PRICING } from './workUnits';

/**
 * The page's meta description, DERIVED rather than typed.
 *
 * It used to be a string literal carrying "2,200 PRO Work Units", "$3,200/mo" and "20% off" by hand. The page body
 * renders every one of those from src/config/workUnits.ts and so cannot drift, but this line sat outside that guarantee
 * and outside check-public-pricing-sync.mjs (which scans public/*, not src/*) — so a ladder change would have left the
 * search result and the social card quoting a price the page no longer offered.
 */
export const PRICING_META_DESCRIPTION = [
  `published pricing: a Prest0n professional — a full-time digital employee with`,
  `${MONTHLY_WU_PER_PRESTON.toLocaleString('en-US')} ${WU_FULL_NAME} per month —`,
  `from $${WU_PRICING.annual.monthlyUsd.toLocaleString('en-US')}/mo on an annual hire.`,
  `hire more, pay less automatically; prepay the year for`,
  `${WU_PRICING.prepayDiscountPct}% off. identical for everyone; free to start.`,
].join(' ');

/** Where search files the pricing page, whichever address served it. */
export const PRICING_CANONICAL_URL = 'https://prest0.ai/pricing';

/** The props both pricing pages hand to <SeoHead>. */
export const PRICING_SEO = {
  title: 'Pricing — prest0 | Hire an AI Employee You Train Up',
  description: PRICING_META_DESCRIPTION,
  canonicalUrl: PRICING_CANONICAL_URL,
  keywords: 'prest0 pricing, AI employee, hire an AI employee, trainable AI assistant, enterprise AI license, AI for law finance, work units',
} as const;
